import React from 'react';
import {
  Box,
  Flex,
  Text,
  Skeleton,
  Container,
  Img,
  Grid,
  GridItem,
} from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import PelatihanImage from '../../assets/webp/pelatihan-card-icon.webp';
import KnowledgeImage from '../../assets/webp/pusat-berbagi-pengetahuan-icon.webp';
import KlinikPengetahuanImage from '../../assets/webp/pusat-pembelajaran-terbimbing-icon.webp';
import BgNewPintar from '../../assets/webp/bg-new-pintar.webp';
import { PiBookOpen, PiCircuitry, PiPlayCircle } from 'react-icons/pi';

// Komponen untuk CardItem
interface CardItemProps {
  imageSrc: string;
  imageAlt: string;
  title: string;
  description: string;
  navigatePath: string;
  icon: JSX.Element;
  iconColor: string;
}

const CardItem: React.FC<CardItemProps> = ({
  imageSrc,
  imageAlt,
  title,
  description,
  navigatePath,
  icon,
  iconColor,
}) => {
  const history = useHistory();

  const handleNavigate = () => {
    history.push(navigatePath);
    window.scrollTo(0, 0);
  };

  return (
    <GridItem
      colSpan={1}
      rounded="lg"
      overflow="hidden"
      display="flex"
      flexDirection="column"
      w="350px"
      h="350px"
      border="1px solid"
      borderColor="gray.200"
      position="relative"
      bg="linear-gradient(132.77deg, #FFFFFF 25.97%, #E3FFF5 111.51%)"
      role="group"
      _hover={{
        cursor: 'pointer',
        bg: 'linear-gradient(155.11deg, #1DB254 15.85%, #E2FF7D 104.28%)',
        color: 'white',
        transition: 'transform 0.3s ease',
      }}
      onClick={handleNavigate}
    >
      <Box px={6} py={4}>
        <Box color={iconColor} _groupHover={{ color: 'white' }}>
          {icon}
        </Box>
        <Flex
          direction="column"
          justifyContent="space-between"
          flex="1"
          className="mt-8"
        >
          <Text fontWeight="semibold" mb={2} fontSize="2xl">
            {title}
          </Text>
          <Text fontSize="sm">{description}</Text>
        </Flex>
      </Box>
      <Img
        src={imageSrc}
        fallback={<Skeleton h="full" w="full" />}
        alt={imageAlt}
        style={{ width: '210px', position: 'absolute', right: 0, bottom: 0 }}
      />
    </GridItem>
  );
};

const TrainingKnowledge: React.FC = () => {
  return (
    <Box
      backgroundImage={`url(${BgNewPintar})`}
      backgroundSize="cover"
      backgroundPosition="center"
      backgroundRepeat="no-repeat"
    >
      <Container maxW="8xl" my={{ base: 8, md: 12 }}>
        <Grid
          templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(3, 0.3fr)' }}
          alignItems="center"
          justifyContent="center"
          justifyItems="center"
          gap={4}
        >
          <CardItem
            imageSrc={PelatihanImage}
            imageAlt="Gambar Pelatihan"
            title="Pusat Pembelajaran Mandiri"
            description="Ikuti Pelatihan untuk tingkatkan kompetensi anda"
            navigatePath="/pelatihan"
            icon={<PiBookOpen size={40} />}
            iconColor="green.500"
          />
          <CardItem
            imageSrc={KlinikPengetahuanImage}
            imageAlt="Gambar Klinik Pengetahuan"
            title="Pusat Pembelajaran Terbimbing"
            description="Ikuti materi Pengetahuan untuk tingkatkan kualifikasi anda"
            navigatePath="/klinik-pengetahuan"
            icon={<PiCircuitry size={40} />}
            iconColor="yellow.500"
          />
          <CardItem
            imageSrc={KnowledgeImage}
            imageAlt="Gambar Berbagi Pengetahuan"
            title="Pusat Berbagi Pengetahuan"
            description="Ikuti materi Pengetahuan untuk tingkatkan kualifikasi anda"
            navigatePath="/daftar-pengetahuan"
            icon={<PiPlayCircle size={40} />}
            iconColor="red.500"
          />
        </Grid>
      </Container>
    </Box>
  );
};

export default TrainingKnowledge;
